/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1
 */

export type NotificationStatus = typeof NotificationStatus[keyof typeof NotificationStatus];


export const NotificationStatus = {
  All: 'All',
  Unread: 'Unread',
} as const;
